<section class="card">
    <div class="card-header">
        <span class="cat__core__title">
            <strong id="pageTitle">SH-6 Register of Employee Stock Options</strong>
        </span>
      <span style="float:right">
        <!-- <a routerLink="/sh6"> -->
          <button (click)="addsh6()" class="btn btn-success pull-right" class="btn btn-sm btn-primary mb-2" type="button"
          [appHasPermission]="{'Url': '/register/mastersh6/edit?goveva=true&email=', 'method':'put', 'menu': 'mastersh6'}">
            <i class="fa fa-plus"></i>&nbsp;Add</button>
        <!-- </a> -->
      </span>
      <span style="float:right">
        <button class="btn btn-success pull-right" class="btn btn-sm btn-primary mb-2" style="margin-right: 8px;" (click)="generateOutput()" type="button">
          <span>
            <i class="fa fa-save"></i>&nbsp;Generate Output </span>
        </button>
      </span>
    </div>
              <section class="card search-box">
                <div class="card-header"(click)="toggleSearchDiv()" style="cursor: pointer;">Modify Search <span class="pull-right"><i class="fa fa-filter" aria-hidden="true"></i></span>
                 </div>
                <div class="card-block collapse" id="search-div" [ngClass]="{'collapse': !isSearchDivVisible}">
                  <div class="row">
                    <div class="col-lg-12">
                        <div class="row">
                          <div class="col-md-3">
                            <label>Grantee Name
                            </label>
                            <input type="text" class="form-control" name="nameOfTheGrantee" [(ngModel)]="nameOfTheGrantee">
                          <br>
                          </div>
                          <!-- <div class="col-md-4">
                            <label>Date on which options exercised</label>
                            <div class="input-group" (click)="$event.stopPropagation()">
                              <input id="dateOnWhichOptionsExcercised" class="form-control" style="padding:6px;z-index: 0;"
                                placeholder="dd-mm-yyyy" name="dateOnWhichOptionsExcercised" ngbDatepicker #cesDate="ngbDatepicker"
                                (click)="cesDate.toggle()" [(ngModel)]="dateOnWhichOptionsExcercised">
                              <button class="input-group-addon" (click)="cesDate.toggle()" type="button">
                                <span class="fa fa-calendar" style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                              </button>
                            </div>
                          </div> -->


                          <div class="col-md-3">
                            <!-- <label>Date of Option Exercised</label> -->
                            <!-- <label>From</label> -->
                            <br>
                            <div class="input-group" (click)="$event.stopPropagation()">
                              From :&nbsp;
                              <input id="dateOnWhichOptionsExcercised" class="form-control"
                                style="padding:6px;z-index: 0;" placeholder="dd-mm-yyyy" name="dateOnWhichOptionsExcercised" ngbDatepicker
                                #ab="ngbDatepicker" (click)="ab.toggle();bc.close()" [(ngModel)]="dateOnWhichOptionsExcercised">
                              <button class="input-group-addon" (click)="ab.toggle();bc.close()" type="button">
                                <span class="fa fa-calendar" style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                              </button>
                            
                            </div>
                          </div>
              
              
                          <div class="col-md-3">
                            <!-- <label>Date of Special Resolution</label> -->
                            <!-- <label>To</label> -->
                            <br>
                            <div class="input-group" (click)="$event.stopPropagation()">
                            
                               To :&nbsp;
                              <input id="dateOfSpecialResolution" class="form-control"
                              style="padding:6px;z-index: 0;" placeholder="dd-mm-yyyy" name="dateOfSpecialResolution" ngbDatepicker
                              #bc="ngbDatepicker" (click)="bc.toggle();ab.close()" [(ngModel)]="dateOfSpecialResolution">
                            <button class="input-group-addon" (click)="bc.toggle();;ab.close()" type="button">
                              <span class="fa fa-calendar" style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                            </button>
                            </div>
                          </div>
              






                          <div class="col-md-3">
                            <br>
                            <!-- <label>&nbsp;&nbsp;&nbsp;</label> -->
                            <div class="input-group">
                              <button type="button" [disabled]="response" class="btn btn-sm btn-primary mb-2" (click)="doAdvSearch()">
                                <i class="fa fa-search"></i>&nbsp;Search</button>
                              &nbsp;&nbsp;&nbsp;
                              <button type="button" [disabled]="response" class="btn btn-sm btn-default mb-2" (click)="clearAdvSearch()">
                                <i class="fa fa-refresh"></i>&nbsp;Clear</button>
                            </div>
                          </div>
                        </div>
                     
                    </div>
                  </div>
                </div>
              </section>
             
              <div class="card-block datatable-card-block">
                <div class="row">
                  <div class="col-md-12">
                    <div class="margin-bottom-50">
                      <div class="table-responsive">
                        <table datatable [dtOptions]="dtOptionsOfRegisterDirector" [dtTrigger]="dtTriggerRegisterDirector" class="table table-hover compact cell-border nowrap stripe"
                               id="directormastersh6Table" style="cursor: pointer;">
                          <thead>
                          <tr>
                            <th>Grantee Name</th>
                            <th>Exercise period-(Months)</th>
                            <th>Exercise price</th>
                            <th>Total shares</th>

                            <th>Date of Option <br>Exercised</th>
                            <th style="display: none">Date of Option Exercised</th>

                            <th>Date of Special <br>Resolution</th>
                            <th style="display: none">Date of Special Resolution</th>
                            <th class="actionclass">Action</th>
                           </tr> 
                          </thead>
                          <tbody>
                            <tr *ngFor="let director of registerDirectorList;let i=index">
                              <td tabindex="1"> 
                                {{director.nameOfTheGrantee}}
                              </td>
                              
                                <td tabindex="2">
                                  {{director.excercisePeriod}} 
                                </td>    
                              <td tabindex="2">
                                  {{director.excercisePrice}}
                                </td>
                              <td tabindex="1">
                                  {{director.numberOfSharesArisingAsResultOfExcerciseOfOption}}
                              </td> 
                              
                              <td tabindex="1">
                    <span style="display: none">{{director.dateOnWhichOptionsExcercised | date : "yMMdd"}}</span>
                    {{director.dateOnWhichOptionsExcercised | date:'dd-MM-y'}}
                  </td>
                  <td tabindex="1" style="display: none">
                    {{director.dateOnWhichOptionsExcercised | date:'dd-MM-y'}}
                  </td>

                  <td tabindex="1">
                    <span style="display: none">{{director.dateOfSpecialResolution | date : "yMMdd"}}</span>
                    {{director.dateOfSpecialResolution | date:'dd-MM-y'}}
                  </td>
                  <td tabindex="1" style="display: none">
                    {{director.dateOfSpecialResolution | date:'dd-MM-y'}}
                  </td>
                              <td>
                                  <div class="input-group">
                                      <button type="button" (click)="editsh6(director._id)" class="btn-sm btn btn-warning" [appHasPermission]="{'Url': '/register/mastersh6/edit?goveva=true&email=', 'method':'put', 'menu': 'mastersh6'}">
                                        <span class="fa fa-pencil"></span>
                                      </button>
                                      &nbsp;&nbsp;
                                <button type="button" class="btn-sm btn btn-danger" (click)="confirmDelete(director._id)" [appHasPermission]="{'Url': '/register/mastersh6/edit?goveva=true&email=', 'method':'put', 'menu': 'mastersh6'}">
                                  <span class="icmn-bin" ></span>
                                </button>
                                  </div>
                              </td>  
                              </tr>
                            </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
           
  </section>
  
                           
  <div class="modal fade" id="deleteConfirm" tabindex="-1" role="dialog" aria-labelledby="" aria-hidden="true"
  style="top: 50px;">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="myModalLabelForDelete">
          <i class="fa fa-question-circle-o mr-2"></i>Confirm</h5>
        <button aria-label="Close" class="close" data-dismiss="modal" type="button">
          <i class="fa fa-times"></i>
        </button>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-sm-12">
            Are you sure you want to delete SH6 details?
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-sm btn-danger" (click)="removesh6detail()">
          <i class="fa fa-check"></i>&nbsp;Yes
        </button>
        <button type="button" class="btn btn-sm btn-primary" data-dismiss="modal">
          <i class="fa fa-times"></i>&nbsp;No
        </button>
      </div>
    </div>
  </div>
</div>
<app-alert></app-alert>
